export default __webpack_public_path__ + "static/media/pic3.41bcf312.jpg";